<template>
  <div class="notifications">
    <div class="notifications__main">
      <v-container>
        <header>{{ notificationConstants.NOTIFICATIONS }}</header>
        <span>{{ notificationConstants.DESC }}</span>
        <v-flex class="notifications__list-details">
          <v-flex>
            <v-flex v-if="success" class="alert__box__success" xs12>
              <v-icon>check</v-icon>
              {{ notificationConstants.SAVE_CONFIRMATION }}
            </v-flex>
            <v-flex v-if="error" class="alert__box__failure" xs12>
              <v-icon>check</v-icon>
              {{ notificationConstants.SAVE_ERROR }}
            </v-flex>
          </v-flex>
          <v-flex class="member" grid-list-md>
            <v-layout row wrap>
              <v-flex class="membertext" text-xs-left xs4>{{ notificationConstants.MEMBER_ACTIVITY }}</v-flex>
              <v-flex text-xs-center xs2>{{ notificationConstants.ON_CONNECT }}</v-flex>
              <v-flex text-xs-center xs2>{{ notificationConstants.MOBILE_ALERTS }}</v-flex>
              <v-flex text-xs-center xs4>{{ notificationConstants.NOTIFY_ME_FOR }}</v-flex>
            </v-layout>
          </v-flex>
          <v-flex class="options" grid-list-md>
            <v-layout v-for="(memberActivity, index) in memberActivities" :key="memberActivity.id" class="options__row" row
                      wrap>
              <v-flex text-xs-left xs4>
                <strong>{{ memberActivity.title }}</strong>
                <v-card-text class="desc">{{ memberActivity.description }}</v-card-text>
              </v-flex>
              <v-flex text-xs-center xs2>
                <v-checkbox v-model="memberActivity.onExchange" :data-qe-id="'memberActivity_onExchange_'+index" class="box" color="ypo_blue"
                            v-on:change="click()"></v-checkbox>
              </v-flex>
              <v-flex text-xs-center xs2>
                <v-checkbox v-model="memberActivity.mobileAlerts" :data-qe-id="'memberActivity_mobileAlerts_'+index" class="box" color="ypo_blue"
                            v-on:change="click()"></v-checkbox>
              </v-flex>
              <notify-me-for
                  :ref="`memberActivity-${memberActivity.id}`"
                  :click="click"
                  :communities="communities"
                  :notify-all-members="memberActivity.notifyAllMembers"
                  :notify-selected-communities="memberActivity.selectedCommunities ? memberActivity.selectedCommunities : []"
                  :rename-new-activity="memberActivity.renameNewActivity"/>
            </v-layout>
          </v-flex>
        </v-flex>
      </v-container>
      <status-overlay :action="loadNotificationsAction" content-height="500px">
      </status-overlay>
    </div>
    <div class="notifications__footer">
      <v-layout row wrap>
        <v-flex class="footer" text-xs-center xs12>
          <v-progress-linear
              v-show="addNotificationAction && addNotificationAction.pending"
              class="ma-0"
              indeterminate
          ></v-progress-linear>
          <v-btn class="primary_btn transparent" data-qe-id="notifications_cancelBtn" @click="cancel()">
            {{ appCommonConstants.CANCEL }}
          </v-btn>
          <v-btn :disabled="isDisabled" class="primary_btn" data-qe-id="notifications_saveBtn" @click="submit">
            {{ appCommonConstants.SAVE }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { notificationConstants } from "./privacysettings.constants.js";
import { mapActions, mapGetters, mapState } from 'vuex';
import { storeAction } from '../../store/storeActions.constant';
import { storeGetters } from '../../store/storeGetters.constant';
import NotifyMeFor from './NotifyMeFor';
import { appCommonConstants } from "../appCommon.constants.js";
import { VProgressLinear } from 'vuetify/es5/components/VProgressLinear';
import StatusOverlay from '../StatusOverlay/StatusOverlay';

export default {
  name: "Notification",
  data: () => ({
    appCommonConstants,
    notificationConstants,
    isDisabled: true,
    memberActivities: [],
    ypoAnnouncements: [],
    events: [],
    communities: [],
    success: false,
    error: false,
  }),
  components: {
    NotifyMeFor,
    VProgressLinear,
    StatusOverlay,
  },
  created() {
    this.getNotification();
  },
  methods: {
    ...mapActions({
      getNotification: `myAccount/${storeAction.getNotification}`,
      saveNotification: `myAccount/${storeAction.saveNotification}`,
    }),
    cancel() {
      this.getNotification();
      this.isDisabled = true;
      this.memberActivities.forEach((x) => {
        const [ref] = this.$refs[`memberActivity-${x.id}`];
        ref.initializeSelectionData();
      });
    },
    click() {
      this.isDisabled = false;
      this.success = false;
      this.error = false;
    },
    dontNotifyMe() {
      this.isDisabled = false;
      this.success = false;
      this.error = false;
    },
    showHideDropdown(memberActivityTitle) {
      this.titleKey = memberActivityTitle;
    },
    submit() {
      const postBody = {};
      postBody.notifications = [
        ...this.memberActivities.map((memberActivity) => {
          const [ref] = this.$refs[`memberActivity-${memberActivity.id}`];
          return {
            ...memberActivity,
            notifyAllMembers: ref ? ref.allMembersCheckbox : '',
            selectedCommunities: ref && ref.getCommunities ? ref.getCommunities() : [],
          };
        }),
        ...this.ypoAnnouncements,
        ...this.events,
      ];
      this.saveNotification(postBody)
          .then(() => {
            this.isDisabled = true;
            this.success = true;
            this.scrollToTop();
          })
          .catch(() => {
            this.error = true;
            this.isDisabled = true;
            this.scrollToTop();
          });
    },
    scrollToTop() {
      let y1 = window.scrollY;
      y1 -= 100;
      document.body.scrollTop = y1;
      document.documentElement.scrollTop = y1;
      if (y1 > 0) {
        const self = this;
        setTimeout(() => {
          self.scrollToTop();
        }, 10);
      }
    },
  },
  computed: {
    ...mapGetters({
      notificationInformation: `myAccount/${storeGetters.notificationInformation}`,
    }),
    ...mapState('actionState', ['actions']),
    addNotificationAction() {
      return this.actions[storeAction.saveNotification];
    },
    loadNotificationsAction() {
      return this.actions[storeAction.getNotification];
    },
  },
  watch: {
    notificationInformation(val) {
      if (val.notifications) {
        this.memberActivities = val.notifications.filter(i => i.categoryType === "Member Activities");
        this.ypoAnnouncements = val.notifications.filter(i => i.categoryType === "YPO Announcements");
        this.events = val.notifications.filter(i => i.categoryType === "Events");
        this.communities = val.communities;
        return;
      }
      if (val) {
        this.memberActivities = val.filter(i => i.categoryType === "Member Activities");
        this.ypoAnnouncements = val.filter(i => i.categoryType === "YPO Announcements");
        this.events = val.filter(i => i.categoryType === "Events");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/responsive.scss";

.notifications {
  background: $white;
  position: relative;

  &__main {
    margin-bottom: 80px;

    @include breakpoint(xs) {
      margin-bottom: 140px;
    }
  }

  &__footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: $ypo-tile-border;
    padding: 10px;

    @include breakpoint(xs) {
      background-color: $white;
      height: 130px;
      border-top: 1px solid $ypo-medium-gray;
    }
  }

  .alert__box {
    &__success {
      background: $ypo-gold;
      color: $white;
      position: relative;
      padding: 10px 0 10px 80px;
      font-size: 12px;
      text-transform: initial;
      line-height: normal;
      margin-left: -25px;

      i {
        font-size: 28px !important;
        color: $white !important;
        position: absolute;
        left: 40px;
        top: 0;
        bottom: 0;
      }
    }

    &__failure {
      background: $ypo-red;
      color: $white;
      position: relative;
      padding: 10px 0 10px 80px;
      font-size: 12px;
      text-transform: initial;
      line-height: normal;
      margin-left: -25px;

      i {
        font-size: 28px !important;
        color: $white !important;
        position: absolute;
        left: 40px;
        top: 0;
        bottom: 0;
      }
    }
  }

  header {
    color: $ypo-blue;
    font-family: Raleway;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: -0.3px;
    line-height: 42px;
    padding: 20px 0px 0px 0px;
  }

  span {
    color: $ypo-dark-gray;
    font-family: Raleway;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.09px;
    line-height: 24px;
  }

  .member {
    color: $ypo-blue;
    font-family: Noto Sans, sans-serif;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: -0.18px;
    line-height: 40px;
    margin-bottom: 15px;
    padding: 15px 0 0px 0;
    border-bottom: 1px solid $ypo-text-border;

    .membertext {
      font-size: 20px;
    }
  }

  .options {
    padding: 0;

    &__row {
      position: relative;
      position: relative;
      margin: 0 0 10px 0 !important;
      background: $ypo-extra-light-gray;
      padding: 5px 0px;

      &:nth-child(2n + 1) {
        background: transparent;
      }
    }

    strong {
      color: $black;
      font-family: "Noto Sans";
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.29px;
      line-height: 24px;
    }

    .desc {
      padding: 0px;
      font-size: 14px;
    }

    .box {
      display: inline-block;
    }

    .notify {
      padding: 0 0 0 0;
      margin: 0 0 0 0;
    }
  }

  @media (max-width: 767px) {
    margin-top: 0 !important;

    .member {
      border-bottom: none;
    }
    .member::after {
      content: '';
      display: block;
      width: 585px;
      border-bottom: 1px solid $ypo-text-border;
    }
    .options {
      .desc {
        font-size: 13px;
      }
    }
  ;
    header {
      padding: 10px 20px 0px 20px;
      font-size: 18px;
      line-height: inherit;
      font-weight: 500;
    }
    span {
      display: inline-block;
      margin: 0;
      padding: 5px 20px 0px 20px;
      font-size: 13px;
      line-height: inherit;
      font-weight: 500;
      color: $black;
    }
    .member {
      font-size: 13px;
      max-width: 600px;
      width: 600px;
      font-weight: 400;

      .membertext {
        font-size: 13px;
      }
    }
    &__list-details {
      overflow: auto;
      padding: 0 10px;

      .options {
        max-width: 600px;
        width: 600px;

        strong {
          font-size: 13px;
        }
      }
    }
  }
}
</style>
